import React from "react";

export const AppFormContext = React.createContext();
